import { Box, VStack } from '@chakra-ui/react';
import React from 'react';

interface WelcomeLayoutProps {
  children: React.ReactNode;
  variant: 'loading' | 'success';
}

export const WelcomeLayout: React.FC<WelcomeLayoutProps> = ({ children, variant }) => {
  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" p={4}>
      <Box bg="softCream" rounded="xl" p={{ base: 8, md: 12 }} maxW="540px" w="full">
        <VStack gap={6}>{children}</VStack>
      </Box>
    </Box>
  );
};
